import { useState } from 'react'

export default function Coach({ session, behavior, streak }) {
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      text: `Hey — I'm your recovery coach. I'm here whenever you need to talk. How are you feeling today?`
    }
  ])
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)

  async function sendMessage() {
    if (!input.trim() || loading) return

    const userMessage = input.trim()
    setInput('')
    setMessages(prev => [...prev, { role: 'user', text: userMessage }])
    setLoading(true)

    try {
      const response = await fetch('/api/coach', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: userMessage,
          behavior: behavior,
          streak: streak,
        }),
      })

      const data = await response.json()
      setMessages(prev => [...prev, { role: 'assistant', text: data.reply }])
    } catch (err) {
      setMessages(prev => [...prev, {
        role: 'assistant',
        text: "Sorry, I'm having trouble connecting. Try again in a moment."
      }])
    }

    setLoading(false)
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') sendMessage()
  }

  return (
    <div style={styles.container}>
      <div style={styles.inner}>

        <div style={styles.header}>
          <h2 style={styles.title}>AI Coach</h2>
          <div style={styles.onlineDot} />
        </div>

        <div style={styles.proNote}>
          <p style={styles.proNoteText}>
            🤖 Powered by Claude AI — available 24/7
          </p>
        </div>

        <div style={styles.messages}>
          {messages.map((msg, i) => (
            <div
              key={i}
              style={{
                ...styles.messageBubble,
                alignSelf: msg.role === 'user' ? 'flex-end' : 'flex-start',
                background: msg.role === 'user'
                  ? 'linear-gradient(135deg, #7c3aed, #2563eb)'
                  : 'rgba(255,255,255,0.06)',
                borderRadius: msg.role === 'user'
                  ? '18px 18px 4px 18px'
                  : '18px 18px 18px 4px',
              }}
            >
              <p style={styles.messageText}>{msg.text}</p>
            </div>
          ))}
          {loading && (
            <div style={{
              ...styles.messageBubble,
              alignSelf: 'flex-start',
              background: 'rgba(255,255,255,0.06)',
              borderRadius: '18px 18px 18px 4px',
            }}>
              <p style={{ ...styles.messageText, color: 'rgba(255,255,255,0.4)' }}>
                Thinking...
              </p>
            </div>
          )}
        </div>

        <div style={styles.inputRow}>
          <input
            style={styles.input}
            placeholder="How are you feeling?"
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button
            style={{
              ...styles.sendBtn,
              opacity: loading ? 0.5 : 1,
            }}
            onClick={sendMessage}
            disabled={loading}
          >
            →
          </button>
        </div>

      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#080812',
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 20px 120px',
  },
  inner: {
    width: '100%',
    maxWidth: 400,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },
  title: {
    color: '#fff',
    fontFamily: 'serif',
    fontSize: 24,
    margin: 0,
  },
  onlineDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: '#4ade80',
  },
  proNote: {
    background: 'rgba(167,139,250,0.08)',
    border: '1px solid rgba(167,139,250,0.15)',
    borderRadius: 12,
    padding: '10px 14px',
    marginBottom: 20,
  },
  proNoteText: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
    margin: 0,
  },
  messages: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginBottom: 16,
    minHeight: 400,
  },
  messageBubble: {
    maxWidth: '80%',
    padding: '12px 16px',
  },
  messageText: {
    color: '#fff',
    fontSize: 14,
    margin: 0,
    lineHeight: 1.6,
  },
  inputRow: {
    display: 'flex',
    gap: 8,
    position: 'fixed',
    bottom: 80,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'calc(100% - 40px)',
    maxWidth: 360,
  },
  input: {
    flex: 1,
    padding: '14px 16px',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 14,
    color: '#fff',
    fontSize: 14,
    outline: 'none',
  },
  sendBtn: {
    width: 48,
    height: 48,
    background: 'linear-gradient(135deg, #7c3aed, #2563eb)',
    border: 'none',
    borderRadius: 14,
    color: '#fff',
    fontSize: 20,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}